import React, { useEffect, useRef } from "react";
import { Button, IconButton, Slider, Stack } from "rsuite";
import { PlayOutline, PauseOutline } from "@rsuite/icons";
import "rsuite/dist/rsuite.min.css";

const YearSlider = ({ years, currentYear, setCurrentYear, playing, setPlaying }) => {
  const intervalRef = useRef(null);

  useEffect(() => {
    if (playing) {
      intervalRef.current = setInterval(() => {
        setCurrentYear(prev => {
          const idx = years.indexOf(prev);
          if (idx < years.length - 1) return years[idx + 1];
          setPlaying(false); 
          return years[0];
        });
      }, 2000);
    } else {
      clearInterval(intervalRef.current);
    }
    return () => clearInterval(intervalRef.current);
  }, [playing, years, setCurrentYear, setPlaying]);

  return (
    <div className="d-flex g-20 align-items-center" style={{height: '40px'} }>
        <IconButton
          icon={playing ? <PauseOutline  /> : <PlayOutline />}
          appearance="primary"
          style={{ background: "#CCDDD1" }}
          onClick={() => setPlaying(!playing)}
        />
        <Slider
          value={currentYear || 0}
          min={years[0] || 0}
          max={years[years.length - 1] || 0}
          step={1}
          progress
          graduated
          renderMark={mark => (years.includes(mark) ? <span>{mark}</span> : null)}
          onChange={value => {
            if (years.includes(value)) setCurrentYear(value);
          }}
          handleClassName="custom-slider-handle"
          barClassName="custom-slider-bar"
          style={{ flexGrow: 1, marginLeft: 20, marginRight: 20, marginBottom: 0 }}
          disabled={years.length === 0}
        />
    </div>
  );
};

export default YearSlider;